export const LEVEL_OPTIONS = [
    { value: 1, label: "1st" },
    { value: 2, label: "2nd" },
    { value: 3, label: "3rd" },
    { value: 4, label: "4th" },
    { value: 5, label: "5th" },
]

export const TERM_OPTIONS = [
    { value: 1, label: "1st" },
    { value: 2, label: "2nd" },
    { value: 3, label: "3rd" },
    { value: 4, label: "4th" },
]

export const WORKFLOW_STATUS_OPTIONS = [
    { value: 'active', label: "Active" },
    { value: 'inactive', label: "Inactive" },
]

export const WORKFLOW_TYPE_OPTIONS = [
    { value: 'admission', label: "Admission" },
]

export const WORKFLOW_COMPONENT_ID_OPTIONS = [
    'profile',
    'upload',
    'entranceExamForm',
    'entranceExamAppointment',
    'admissionBilling',
    'applicationFee',
    'reservationFee',
    'finalApproval',
    'studentProfile',
    'studentRecord',
    'studentRegistration',
    'deniedEmail',
    'failed',
    'passed',
]

export const WORKFLOW_COMPONENT_TYPE_OPTIONS = [
    { value: 'form', label: "Form" },
    { value: 'document', label: "Document" },
    { value: 'approval', label: "Approval" },
    { value: 'notification', label: "Notification" },
    { value: 'statusChange', label: "Status Change" },
]

export const WORKFLOW_COMPONENT_FIELD_TYPE_OPTIONS = [
    { value: 'text', label: "Text" },
    { value: 'upload', label: "Upload" },
    { value: 'selection', label: "Selection" },
    { value: 'boolean', label: "Boolean" },
    { value: 'date', label: "Date" },
    { value: 'time', label: "Time" },
]

export const CIVIL_STATUS_OPTIONS = [
    { value: 'single', label: "Single" },
    { value: 'married', label: "Married" },
]

export const PROGRAM_TYPE_OPTIONS = [
    { value: "basicEd", label: "Basic Education" },
    { value: "college", label: "College Degree" },
    { value: "graduate", label: "Graduate Degree" },
]

export const CAMPUS_OPTIONS = [
    { value: 'main', label: "Main" },
]

export const EXAM_RESULTS_APPLICATION_OPTIONS = [
    { value: 'passed', label: "Passed" },
    { value: 'waitlisted', label: "Waitlisted" },
    { value: 'failed', label: "Failed" },
]

export const DAY_WEEK = [
    {
        value: 1,
        label: 'Monday',
        short: 'Mon',
    },
    {
        value: 2,
        label: 'Tuesday',
        short: 'Tue',
    },
    {
        value: 3,
        label: 'Wednesday',
        short: 'Wed',
    },
    {
        value: 4,
        label: 'Thursday',
        short: 'Thu',
    },
    {
        value: 5,
        label: 'Friday',
        short: 'Fri',
    },
    {
        value: 6,
        label: 'Saturday',
        short: 'Sat',
    },
    {
        value: 7,
        label: 'Sunday',
        short: 'Sun',
    },
]

export const YEAR_OPTIONS = [
    {
        value: 1,
        label: 'First Year',
    },
    {
        value: 2,
        label: 'Second Year',
    },
    {
        value: 3,
        label: 'Third Year',
    },
    {
        value: 4,
        label: 'Fourth Year',
    },
    {
        value: 5,
        label: 'Fifth Year',
    },
]


export const BILLING_STATUS_OPTIONS = [
    { value: 'open', label: "Open" },
    { value: 'paid', label: "Paid" },
    { value: 'cancelled', label: "Cancelled" },
    { value: 'waived', label: "Waived" },
]

export const PAYMENT_STATUS_OPTIONS = [
    { value: 'successful', label: "Successful" },
    { value: 'pending', label: "Pending" },
    { value: 'cancelled', label: "Cancelled" },
]

export const MEMO_STATUS_OPTIONS = [
    { value: 'open', label: "Open" },
    { value: 'cancelled', label: "Cancelled" },
]

export const STUDENT_TYPE_OPTIONS = [
    { value: "regular", label: "Regular" },
    { value: "newStudent", label: "New Student" },
    { value: "graduating", label: "Graduating" },
    { value: "all", label: "All" }
]

export const SCHEDULE_TYPE_OPTIONS = [
    { value: 'appointment', label: 'Appointment' },
    { value: 'examination', label: 'Examination' },
]

export const SCHEDULE_STATUS_OPTIONS = [
    { value: 'open', label: 'Open' },
    { value: 'closed', label: 'Closed' },
]

export const ADMIN_GROUP_OPTIONS = [
    { value: 'accounting', label: 'Accounting' },
    { value: 'admission', label: 'Admission' },
    { value: 'college', label: 'College' },
    { value: 'registrar', label: 'Registrar' },
    { value: 'system', label: 'System' },
]

export const TEMPLATE_STATUS_OPTIONS = [
    { value: "draft", label: "Draft" },
    { value: "published", label: "Published" },
    { value: "archived", label: "Archived" },
]

export const ROLES = {
    // school roles
    admissions: ['admin', 'admission'],
    colleges: ['admin'],
    accounting: ['admin', 'accounting'],
    cashiering: ['admin', 'accounting', 'cashiering'],
    registrar: ['admin', 'registrar'],
    administrator: ['admin'],
    faculty: ['admin', 'faculty'],
    counselor: ['admin', 'counselor'],

    // clinic roles
    admin: ['admin'],
    clinicManager: ['admin', 'clinicManager'],
    inventoryManager: ['admin', 'inventoryManager'],
    doctor: ['admin', 'doctor'],
    therapist: ['admin', 'therapist'],
    hr: ['admin', 'hr'],
    patient: ['patient'],
    employee: ['employee', 'admin', 'inventoryManager', 'clinicManager', 'doctor', 'therapist', 'hr'],
}

export const SY_OPTIONS = [
    { value: '2022 - 2023', label: '2022 - 2023' },
    { value: '2023 - 2024', label: '2023 - 2024' },
    { value: '2024 - 2025', label: '2024 - 2025' },
]

export const FEESCHEDULE_TYPE_OPTIONS = [
    { value: 'days', label: "Days" },
    { value: 'weeks', label: "Weeks" },
    { value: 'months', label: "Months" }
]

export const FEESCHEDULE_REFERENCE_OPTIONS = [
    { value: 'startDate', label: "Start Date" },
    { value: 'finalizedDate', label: "Finalized Date" }
]

export const QUARTER_OPTIONS = [
    { value: '1q', label: '1st Quarter', secondLabel: 'First Quarter' },
    { value: '2q', label: '2nd Quarter', secondLabel: 'Second Quarter' },
    { value: '3q', label: '3rd Quarter', secondLabel: 'Third Quarter' },
    { value: '4q', label: '4th Quarter', secondLabel: 'Fourth Quarter' },
    { value: '5q', label: 'Summer' },
]

export const COURSES_TYPES = [
    { value: 'academic', label: "Academic" },
    { value: 'nonAcademic', label: "Non-Academic" }
]

export const QUESTION_TYPES = ['single-answer', 'single-choice', 'multiple-choice', 'multiple-answer', 'essay', 'file']


export const SEX_OPTIONS = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
]

export const SPECIALIZATION_OPTIONS = [
    { value: "medical", label: "Medical" },
    { value: "aesthetic medicine", label: "Aesthetic Medicine" },
    { value: "dermatophatology", label: "Dermatophatology" },
    { value: "pediatric", label: "Pediatric" }
]

export const ROLE_OPTIONS = [
    { value: "admin", label: "Admin" },
    { value: "clinicManager", label: "Clinic Manager" },
    { value: "inventoryManager", label: "Inventory Manager" },
    { value: "employee", label: " Employee" },
    { value: "doctor", label: "Doctor" },
    { value: "therapist", label: "Therapist" },
    { value: "hr", label: "HR" },
    // { value: "patient", label: "Patient" },
]

export const PRODUCT_TYPE_OPTIONS = [
    { value: "clinic", label: "Clinic Supplies" },
    { value: "office", label: "Office Supplies" },
    { value: "retail", label: "Retail Products" },
    { value: "injectables", label: "MD Injectables" },
]

export const ROOM_OPTIONS = [
    { value: 'tbd', label: 'All' },
    { value: 'alabang:01a', label: 'Alabang Room 1A' },
    { value: 'alabang:01b', label: 'Alabang Room 1B' },
    { value: 'alabang:02', label: 'Alabang Room 2' },
    { value: 'alabang:03', label: 'Alabang Room 3' },
    { value: 'alabang:04', label: 'Alabang Room 4' },
    { value: 'alabang:05', label: 'Alabang Room 5' },
    { value: 'alabang:06', label: 'Alabang Room 6' },
    { value: 'makati:01', label: 'Makati Room 1' },
    { value: 'makati:02', label: 'Makati Room 2' },
    { value: 'makati:03', label: 'Makati Room 3' },
]

export const BRANCH_OPTIONS = [
    // { value: 'alabang', label: 'Alabang' },
    { value: 'makati', label: 'Makati' },
]

export const APPOINTMENT_REASON_OPTIONS = [
    { value: 'checkup', label: 'Checkup' },
    { value: 'consultation', label: 'Consultation' },
    { value: 'follow-up', label: 'Follow-up' },
]

export const APPOINTMENT_STATUS_OPTIONS = [
    { value: 'pending', label: 'Pending' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'completed', label: '✅ Completed' },
    { value: 'canceled', label: '❌ Canceled' },
]

export const SKU_OPTIONS = [
    { value: 'pairs/box', label: 'Pairs/Box' },
    { value: 'pieces/box', label: 'Pieces/Box' },
    { value: 'packs', label: 'Packs' },
    { value: 'ml/bottle', label: 'ml/Bottle' },
    { value: '2 pieces/pack', label: '2 Pieces/Pack' },
    { value: 'pulls/box', label: 'Pulls/Box' },
    { value: 'roll', label: 'Roll' },
    { value: 'pieces', label: 'Pieces' },
    { value: 'pairs', label: 'Pairs' },
    { value: 'boxes', label: 'Boxes' },
    { value: 'jars', label: 'Jars' },
    { value: 'bottles', label: 'Bottles' },
    { value: 'capsules', label: 'Capsules' },
]

export const MOP_OPTIONS = [
    { value: 'cash', label: 'Cash' },
    { value: 'card', label: 'Card' },
    { value: 'check', label: 'Check' },
    { value: 'bt-bdo', label: 'BT BDO' },
    { value: 'bt-bpi', label: 'BT BPI' },
    { value: 'gcash', label: 'GCash' },
    { value: 'maya', label: 'Maya' },
    { value: 'pre-paid', label: 'Pre-paid' },
    { value: 'foc', label: 'FOC' },
]
export const FOC_OPTIONS = [
    { value: 'x-deal', label: 'X-Deal' },
    { value: 'complaint', label: 'Complaint' },
]

export const YES_OR_NO_OPTIONS = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
]

// ['Facial', 'Laser', 'RF', 'Cryo', 'Peel', 'Injection', 'IV', 'Mesotherapy', 'PRP', 'Surgery', 'Others']
export const TREATMENT_OPTIONS = [
    { value: 'facial', label: 'Facial' },
    { value: 'peel', label: 'Peel' },
    { value: 'cryo', label: 'Cryo' },
    { value: 'rf', label: 'RF' },
    { value: 'cavi', label: 'Cavi' },
    { value: 'warts', label: 'Warts' },
    { value: 'others', label: 'Others' },
]

export const ALABANG_MACHINE_OPTIONS = [
    { value: 'revlite', label: 'RevLite' },
    { value: 'fotona', label: 'Fotona' },
    { value: 'hydrafacial', label: 'HydraFacial' },
    { value: 'healite', label: 'Healite' },
]

export const MAKATI_MACHINE_OPTIONS = [
    { value: 'dermav', label: 'DermaV' },
    { value: 'hollywood', label: 'Hollywood' },
    { value: 'genius', label: 'Genius' },
    { value: 'healite', label: 'Healite' },
    { value: 'ultera', label: 'Ultera' },
    { value: 'botox', label: 'Botox' },
    { value: 'radiesse', label: 'Radiesse' },
]

export const TIME_SLOT_OPTIONS = [
    { value: '08:00', label: '08:00 AM' },
    { value: '08:30', label: '08:30 AM' },
    { value: '09:00', label: '09:00 AM' },
    { value: '09:30', label: '09:30 AM' },
    { value: '10:00', label: '10:00 AM' },
    { value: '10:30', label: '10:30 AM' },
    { value: '11:00', label: '11:00 AM' },
    { value: '11:30', label: '11:30 AM' },
    { value: '12:00', label: '12:00 PM' },
    { value: '12:30', label: '12:30 PM' },
    { value: '13:00', label: '01:00 PM' },
    { value: '13:30', label: '01:30 PM' },
    { value: '14:00', label: '02:00 PM' },
    { value: '14:30', label: '02:30 PM' },
    { value: '15:00', label: '03:00 PM' },
    { value: '15:30', label: '03:30 PM' },
    { value: '16:00', label: '04:00 PM' },
    { value: '16:30', label: '04:30 PM' },
    { value: '17:00', label: '05:00 PM' },
    { value: '17:30', label: '05:30 PM' },
    { value: '18:00', label: '06:00 PM' },
    { value: '18:30', label: '06:30 PM' },
    { value: '19:00', label: '07:00 PM' },
    { value: '19:30', label: '07:30 PM' },
    { value: '20:00', label: '08:00 PM' },
    { value: '20:30', label: '08:30 PM' },
]

export const LEAVE_TYPE_OPTIONS = [
    { value: 'casual', label: 'Casual' },
    { value: 'sick', label: 'Sick' },
    { value: 'maternity', label: 'Maternity' },
    { value: 'emergency', label: 'Emergency' },
]

export const LEAVE_STATUS_OPTIONS = [
    { value: 'pending', label: 'Pending' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
]

export const CASH_REQUEST_STATUS_OPTIONS = [
    { value: 'pending', label: 'Pending' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
]

export const CASH_REQUEST_TYPE_OPTIONS = [
    { value: 'Withdraw', label: 'Withdraw' },
    { value: 'Deposit', label: 'Deposit' },
]